import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronDownCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
    <path d="M22.7 13.3a1 1 0 0 0-1.4 0L16 18.6l-5.3-5.3a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.4l6 6a1 1 0 0 0 1.4 0l6-6a1 1 0 0 0 0-1.4" />
  </svg>
);
const ForwardRef = forwardRef(IconChevronDownCircleOutlineSVG);
ForwardRef.displayName = "IconChevronDownCircleOutline";
export { ForwardRef as IconChevronDownCircleOutline };
